import React from "react";
import {
    AppLayout,
    Header,
    SideNavigation,
    Container,
    ContentLayout,
    Cards,
    Box,
    Link,
    SpaceBetween,
    Button,
} from '@cloudscape-design/components';
import HeaderLearnMore from "./HeaderLearnMore";
import "@cloudscape-design/global-styles/index.css"
import { BreadcrumbGroup } from '@cloudscape-design/components';
import { NavigationSide } from "./Navigation";

function LearnMore() {
    return (
        <AppLayout
          navigation={<NavigationSide activeHref="/learnmore"/>}
          content={<MainContent />}
          header={<PageHeader />}
          contentType="dashboard"
          toolsHide={true}
        />
    );
  }
  function Navigation({ activeHref }) {
    return (
      <SideNavigation
        activeHref={activeHref}
        header={{ text: 'AWS Eloquence', href: '/' }}
        items={[
          { type: 'link', text: 'Learn More', href: '/learnmore' },
          { type: 'link', text: 'Get Started', href: '/getstarted' },
          { type: 'link', text: 'My Meetings', href: '/meetings'},
          { type: 'link', text: 'Meet the Team', href: '/meettheteam'},
          { type: 'link', text: 'Architecture Diagram', href: '/architecture'},
          { type: 'divider' },
          { type: 'link', text: 'Documentation', href: '/documentation' },
        ]}
      />
    );
  }
  
  function MainContent() {
      return (
        <>
        <BreadcrumbGroup
            items={[
              { text: "Home", href: "/" },
              { text: "Learn More", href: "/learnmore" },
            ]}
            ariaLabel="Breadcrumbs"
          />
        <ContentLayout
          header={
            <SpaceBetween size="m">
            <Header variant="h1"> </Header>
            <HeaderLearnMore></HeaderLearnMore>
          </SpaceBetween>
          }
        >
          <SpaceBetween size="l">

          </SpaceBetween>
      </ContentLayout>
      </>
    );
  }
  function PageHeader() {
    return (
      <Header
        variant="h1"
        actions={
          <div>
            {/* Add any header actions here */}
          </div>
        }
      >
        My Application
      </Header>
    );
  }
  export default LearnMore;
